import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const PrivacyPage: React.FC = () => {
  const { language, translations } = useLanguage();

  return (
    <div className="container mx-auto px-4 pt-32 pb-8 max-w-5xl">
      <h1 className="text-3xl font-bold text-center mb-8">{translations.privacy.title}</h1>
      
      <div className="prose max-w-none">
        {language === 'de' && (
          <div className="mb-12">
            <h2 className="text-2xl font-semibold mb-4">Deutsch</h2>
            <h3 className="text-xl font-semibold mb-3">Datenschutzerklärung</h3>
            <p className="mb-4">Wir, die Seadent Mallorca (im Folgenden "wir" oder "Seadent"), nehmen den Schutz Ihrer personenbezogenen Daten sehr ernst. Diese Datenschutzerklärung informiert Sie darüber, wie wir Ihre Daten erheben, verarbeiten und schützen, wenn Sie unsere Website besuchen oder unsere Dienstleistungen nutzen. Sie entspricht den Anforderungen der Datenschutz-Grundverordnung (DSGVO) und den geltenden spanischen Datenschutzgesetzen.</p>
            
            <h4 className="text-lg font-semibold mb-2">1. Verantwortlicher</h4>
            <p className="mb-4">Verantwortlicher im Sinne der DSGVO ist:<br />
            Jan D. Heiringhoff<br />
            Seadent Mallorca<br />
            Avenida de Jaime III, 3, 07012 Palma, Illes Balears, Spanien<br />
            Telefon: +34 603 31 96 48<br />
            E-Mail: info@seadent.es</p>
            
            <h4 className="text-lg font-semibold mb-2">2. Erhebung und Verarbeitung personenbezogener Daten</h4>
            <p className="mb-2">Wir erheben personenbezogene Daten, wenn Sie:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Unsere Website besuchen (z. B. durch Cookies oder Google Analytics, sofern Sie zugestimmt haben).</li>
              <li>Uns über das Kontaktformular, per E-Mail oder telefonisch kontaktieren.</li>
              <li>Einen Termin vereinbaren oder unsere Dienstleistungen in Anspruch nehmen.</li>
            </ul>
            <p className="mb-2">Arten von Daten:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Nutzungsdaten: IP-Adresse, Browser-Typ, Betriebssystem, besuchte Seiten, Uhrzeit und Dauer des Besuchs (über Google Analytics).</li>
              <li>Kontaktdaten: Name, E-Mail-Adresse, Telefonnummer, Nachricht (bei Nutzung des Kontaktformulars).</li>
              <li>Gesundheitsdaten: Daten im Zusammenhang mit zahnärztlichen Behandlungen (z. B. Terminanfragen, Behandlungsdetails), die nur mit Ihrer ausdrücklichen Einwilligung verarbeitet werden.</li>
            </ul>
            
            <h4 className="text-lg font-semibold mb-2">3. Zwecke der Datenverarbeitung</h4>
            <p className="mb-2">Wir verarbeiten Ihre Daten für folgende Zwecke:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Bereitstellung und Optimierung unserer Website (z. B. durch Analyse des Nutzerverhaltens).</li>
              <li>Beantwortung Ihrer Anfragen und Terminvereinbarungen.</li>
              <li>Durchführung zahnärztlicher Behandlungen und Notfalldienste.</li>
              <li>Erfüllung gesetzlicher Verpflichtungen (z. B. Dokumentation von Behandlungen).</li>
            </ul>
            
            <h4 className="text-lg font-semibold mb-2">4. Google Analytics</h4>
            <p className="mb-4">Unsere Website nutzt Google Analytics, einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland ("Google"). Google Analytics verwendet Cookies, um das Nutzerverhalten auf unserer Website zu analysieren. Die erzeugten Informationen (z. B. IP-Adresse, besuchte Seiten) werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert.</p>
            <p className="mb-2">Datenschutzmaßnahmen:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Wir haben mit Google einen Auftragsverarbeitungsvertrag (Data Processing Agreement) abgeschlossen.</li>
              <li>Ihre IP-Adresse wird vor der Übermittlung anonymisiert (IP-Anonymisierung).</li>
              <li>Sie können die Erhebung durch Google Analytics verhindern, indem Sie Ihre Einwilligung im Cookie-Banner verweigern oder Cookies in Ihrem Browser deaktivieren.</li>
              <li>Weitere Informationen finden Sie in der Datenschutzerklärung von Google.</li>
            </ul>
            
            <h4 className="text-lg font-semibold mb-2">5. Cookies</h4>
            <p className="mb-4">Unsere Website verwendet Cookies, um die Benutzerfreundlichkeit zu verbessern und Nutzungsdaten zu analysieren. Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden.</p>
            <p className="mb-2">Arten von Cookies:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Notwendige Cookies: Erforderlich für die Funktion der Website (z. B. Navigation).</li>
              <li>Analyse-Cookies: Ermöglichen die Analyse des Nutzerverhaltens (z. B. Google Analytics).</li>
            </ul>
            <p className="mb-4">Sie können Ihre Cookie-Einstellungen jederzeit über das Cookie-Banner anpassen oder Cookies in Ihrem Browser deaktivieren. Ohne Ihre ausdrückliche Zustimmung werden keine Analyse-Cookies gesetzt.</p>
            
            <h4 className="text-lg font-semibold mb-2">6. Ihre Rechte</h4>
            <p className="mb-2">Gemäß DSGVO haben Sie folgende Rechte:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Auskunftsrecht: Recht auf Auskunft über die von uns verarbeiteten Daten.</li>
              <li>Berichtigungsrecht: Recht auf Berichtigung unrichtiger Daten.</li>
              <li>Löschungsrecht: Recht auf Löschung Ihrer Daten ("Recht auf Vergessenwerden").</li>
              <li>Einschränkungsrecht: Recht auf Einschränkung der Verarbeitung.</li>
              <li>Widerspruchsrecht: Recht auf Widerspruch gegen die Verarbeitung (z. B. bei Google Analytics).</li>
              <li>Datenübertragbarkeit: Recht auf Erhalt Ihrer Daten in einem strukturierten Format.</li>
            </ul>
            <p className="mb-4">Bitte kontaktieren Sie uns unter der oben genannten Adresse, um Ihre Rechte auszuüben.</p>
            
            <h4 className="text-lg font-semibold mb-2">7. Datenweitergabe</h4>
            <p className="mb-2">Ihre Daten werden nur weitergegeben, wenn:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Dies zur Erfüllung unserer Dienstleistungen erforderlich ist (z. B. an Labore für Zahnersatz).</li>
              <li>Eine gesetzliche Verpflichtung besteht.</li>
              <li>Sie ausdrücklich eingewilligt haben.</li>
              <li>Google Analytics übermittelt Daten an Google-Server in den USA. Google hält die Anforderungen des EU-US Data Privacy Framework ein.</li>
            </ul>
            
            <h4 className="text-lg font-semibold mb-2">8. Speicherdauer</h4>
            <p className="mb-4">Wir speichern Ihre Daten nur so lange, wie es für die angegebenen Zwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen. Nutzungsdaten (z. B. Google Analytics) werden nach 14 Monaten gelöscht, sofern keine längere Speicherung erforderlich ist.</p>
            
            <h4 className="text-lg font-semibold mb-2">9. Sicherheit</h4>
            <p className="mb-4">Wir setzen technische und organisatorische Maßnahmen ein, um Ihre Daten vor unbefugtem Zugriff, Verlust oder Missbrauch zu schützen (z. B. SSL-Verschlüsselung der Website).</p>
            
            <h4 className="text-lg font-semibold mb-2">10. Kontakt</h4>
            <p className="mb-4">Für Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte kontaktieren Sie uns bitte:<br />
            Seadent Mallorca<br />
            Avenida de Jaime III, 3, 07012 Palma, Illes Balears, Spanien<br />
            Telefon: +34 603 31 96 48 (24/7 Notdienst)<br />
            Öffnungszeiten: Montag bis Freitag, 9:00–18:00 Uhr<br />
            E-Mail: info@seadent.es</p>
            
            <h4 className="text-lg font-semibold mb-2">11. Änderungen dieser Datenschutzerklärung</h4>
            <p className="mb-4">Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen, z. B. bei rechtlichen Änderungen. Die aktuelle Version ist auf unserer Website verfügbar.</p>
            <p className="mb-4">Stand: Mai 2025</p>
          </div>
        )}
        
        {language === 'en' && (
          <div className="mb-12">
            <h2 className="text-2xl font-semibold mb-4">English</h2>
            <h3 className="text-xl font-semibold mb-3">Privacy Policy</h3>
            <p className="mb-4">We, Seadent Mallorca (hereinafter "we" or "Seadent"), take the protection of your personal data very seriously. This privacy policy informs you about how we collect, process, and protect your data when you visit our website or use our services. It complies with the requirements of the General Data Protection Regulation (GDPR) and applicable Spanish data protection laws.</p>
            
            <h4 className="text-lg font-semibold mb-2">1. Controller</h4>
            <p className="mb-4">The controller within the meaning of the GDPR is:<br />
            Jan D. Heiringhoff<br />
            Seadent Mallorca<br />
            Avenida de Jaime III, 3, 07012 Palma, Illes Balears, Spain<br />
            Phone: +34 603 31 96 48<br />
            Email: info@seadent.es</p>
            
            <h4 className="text-lg font-semibold mb-2">2. Collection and Processing of Personal Data</h4>
            <p className="mb-2">We collect personal data when you:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Visit our website (e.g., via cookies or Google Analytics, if you have given consent).</li>
              <li>Contact us via the contact form, email, or phone.</li>
              <li>Book an appointment or use our services.</li>
            </ul>
            <p className="mb-2">Types of Data:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Usage Data: IP address, browser type, operating system, visited pages, time and duration of visit (via Google Analytics).</li>
              <li>Contact Data: Name, email address, phone number, message (when using the contact form).</li>
              <li>Health Data: Data related to dental treatments (e.g., appointment requests, treatment details), processed only with your explicit consent.</li>
            </ul>
            
            <h4 className="text-lg font-semibold mb-2">3. Purposes of Data Processing</h4>
            <p className="mb-2">We process your data for the following purposes:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Providing and optimizing our website (e.g., by analyzing user behavior).</li>
              <li>Responding to your inquiries and scheduling appointments.</li>
              <li>Performing dental treatments and emergency services.</li>
              <li>Complying with legal obligations (e.g., documentation of treatments).</li>
            </ul>
            
            <h4 className="text-lg font-semibold mb-2">4. Google Analytics</h4>
            <p className="mb-4">Our website uses Google Analytics, a web analytics service provided by Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland ("Google"). Google Analytics uses cookies to analyze user behavior on our website. The information generated (e.g., IP address, pages visited) is usually transferred to a Google server in the USA and stored there.</p>
            <p className="mb-2">Data Protection Measures:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>We have concluded a Data Processing Agreement with Google.</li>
              <li>Your IP address is anonymized before transmission (IP anonymization).</li>
              <li>You can prevent data collection by Google Analytics by refusing consent in the cookie banner or disabling cookies in your browser.</li>
              <li>Further information can be found in Google's Privacy Policy.</li>
            </ul>
            
            <h4 className="text-lg font-semibold mb-2">5. Cookies</h4>
            <p className="mb-4">Our website uses cookies to improve user experience and analyze usage data. Cookies are small text files stored on your device.</p>
            <p className="mb-2">Types of Cookies:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Necessary Cookies: Required for the website's functionality (e.g., navigation).</li>
              <li>Analytics Cookies: Enable analysis of user behavior (e.g., Google Analytics).</li>
            </ul>
            <p className="mb-4">You can adjust your cookie settings at any time via the cookie banner or disable cookies in your browser. No analytics cookies are set without your explicit consent.</p>
            
            <h4 className="text-lg font-semibold mb-2">6. Your Rights</h4>
            <p className="mb-2">Under the GDPR, you have the following rights:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Right to Access: Right to obtain information about the data we process.</li>
              <li>Right to Rectification: Right to correct inaccurate data.</li>
              <li>Right to Erasure: Right to have your data deleted ("right to be forgotten").</li>
              <li>Right to Restriction: Right to restrict processing.</li>
              <li>Right to Object: Right to object to data processing (e.g., for Google Analytics).</li>
              <li>Right to Data Portability: Right to receive your data in a structured format.</li>
            </ul>
            <p className="mb-4">Please contact us at the address above to exercise your rights.</p>
            
            <h4 className="text-lg font-semibold mb-2">7. Data Sharing</h4>
            <p className="mb-2">Your data will only be shared if:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>It is necessary to provide our services (e.g., to laboratories for dental prosthetics).</li>
              <li>There is a legal obligation.</li>
              <li>You have given explicit consent.</li>
              <li>Google Analytics transfers data to Google servers in the USA. Google complies with the EU-US Data Privacy Framework.</li>
            </ul>
            
            <h4 className="text-lg font-semibold mb-2">8. Storage Period</h4>
            <p className="mb-4">We store your data only as long as necessary for the specified purposes or as required by legal retention periods. Usage data (e.g., Google Analytics) is deleted after 14 months unless longer storage is required.</p>
            
            <h4 className="text-lg font-semibold mb-2">9. Security</h4>
            <p className="mb-4">We implement technical and organizational measures to protect your data from unauthorized access, loss, or misuse (e.g., SSL encryption of the website).</p>
            
            <h4 className="text-lg font-semibold mb-2">10. Contact</h4>
            <p className="mb-4">For questions about data protection or to exercise your rights, please contact us:<br />
            Seadent Mallorca<br />
            Avenida de Jaime III, 3, 07012 Palma, Illes Balears, Spain<br />
            Phone: +34 603 31 96 48 (24/7 emergency service)<br />
            Opening Hours: Monday to Friday, 9:00 AM–6:00 PM<br />
            Email: info@seadent.es</p>
            
            <h4 className="text-lg font-semibold mb-2">11. Changes to this Privacy Policy</h4>
            <p className="mb-4">We reserve the right to update this privacy policy as needed, e.g., due to legal changes. The current version is available on our website.</p>
            <p className="mb-4">Date: May 2025</p>
          </div>
        )}
        
        {language === 'es' && (
          <div className="mb-12">
            <h2 className="text-2xl font-semibold mb-4">Español</h2>
            <h3 className="text-xl font-semibold mb-3">Política de Privacidad</h3>
            <p className="mb-4">Nosotros, Seadent Mallorca (en adelante, "nosotros" o "Seadent"), tomamos muy en serio la protección de sus datos personales. Esta política de privacidad le informa sobre cómo recopilamos, procesamos y protegemos sus datos cuando visita nuestro sitio web o utiliza nuestros servicios. Cumple con los requisitos del Reglamento General de Protección de Datos (RGPD) y las leyes de protección de datos españolas aplicables.</p>
            
            <h4 className="text-lg font-semibold mb-2">1. Responsable del Tratamiento</h4>
            <p className="mb-4">El responsable del tratamiento en el sentido del RGPD es:<br />
            Jan D. Heiringhoff<br />
            Seadent Mallorca<br />
            Avenida de Jaime III, 3, 07012 Palma, Illes Balears, España<br />
            Teléfono: +34 603 31 96 48<br />
            Correo electrónico: info@seadent.es</p>
            
            <h4 className="text-lg font-semibold mb-2">2. Recopilación y Tratamiento de Datos Personales</h4>
            <p className="mb-2">Recopilamos datos personales cuando usted:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Visita nuestro sitio web (por ejemplo, a través de cookies o Google Analytics, si ha dado su consentimiento).</li>
              <li>Nos contacta a través del formulario de contacto, correo electrónico o teléfono.</li>
              <li>Reserva una cita o utiliza nuestros servicios.</li>
            </ul>
            <p className="mb-2">Tipos de Datos:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Datos de Uso: Dirección IP, tipo de navegador, sistema operativo, páginas visitadas, hora y duración de la visita (a través de Google Analytics).</li>
              <li>Datos de Contacto: Nombre, dirección de correo electrónico, número de teléfono, mensaje (cuando utiliza el formulario de contacto).</li>
              <li>Datos de Salud: Datos relacionados con tratamientos dentales (por ejemplo, solicitudes de citas, detalles del tratamiento), procesados solo con su consentimiento explícito.</li>
            </ul>
            
            <h4 className="text-lg font-semibold mb-2">3. Finalidades del Tratamiento de Datos</h4>
            <p className="mb-2">Procesamos sus datos para los siguientes fines:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Proporcionar y optimizar nuestro sitio web (por ejemplo, mediante el análisis del comportamiento del usuario).</li>
              <li>Responder a sus consultas y programar citas.</li>
              <li>Realizar tratamientos dentales y servicios de emergencia.</li>
              <li>Cumplir con obligaciones legales (por ejemplo, documentación de tratamientos).</li>
            </ul>
            
            <h4 className="text-lg font-semibold mb-2">4. Google Analytics</h4>
            <p className="mb-4">Nuestro sitio web utiliza Google Analytics, un servicio de análisis web proporcionado por Google Ireland Limited, Gordon House, Barrow Street, Dublín 4, Irlanda ("Google"). Google Analytics utiliza cookies para analizar el comportamiento de los usuarios en nuestro sitio web. La información generada (por ejemplo, dirección IP, páginas visitadas) generalmente se transfiere a un servidor de Google en los EE. UU. y se almacena allí.</p>
            <p className="mb-2">Medidas de Protección de Datos:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Hemos suscrito un Acuerdo de Tratamiento de Datos con Google.</li>
              <li>Su dirección IP se anonimiza antes de la transmisión (anonimización de IP).</li>
              <li>Puede evitar la recopilación de datos por parte de Google Analytics al rechazar el consentimiento en el banner de cookies o desactivar las cookies en su navegador.</li>
              <li>Más información en la Política de Privacidad de Google.</li>
            </ul>
            
            <h4 className="text-lg font-semibold mb-2">5. Cookies</h4>
            <p className="mb-4">Nuestro sitio web utiliza cookies para mejorar la experiencia del usuario y analizar datos de uso. Las cookies son pequeños archivos de texto almacenados en su dispositivo.</p>
            <p className="mb-2">Tipos de Cookies:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Cookies Necesarias: Requeridas para el funcionamiento del sitio web (por ejemplo, navegación).</li>
              <li>Cookies de Análisis: Permiten el análisis del comportamiento del usuario (por ejemplo, Google Analytics).</li>
            </ul>
            <p className="mb-4">Puede ajustar la configuración de cookies en cualquier momento a través del banner de cookies o desactivar las cookies en su navegador. No se establecerán cookies de análisis sin su consentimiento explícito.</p>
            
            <h4 className="text-lg font-semibold mb-2">6. Sus Derechos</h4>
            <p className="mb-2">Según el RGPD, usted tiene los siguientes derechos:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Derecho de Acceso: Derecho a obtener información sobre los datos que procesamos.</li>
              <li>Derecho de Rectificación: Derecho a corregir datos inexactos.</li>
              <li>Derecho de Supresión: Derecho a que se eliminen sus datos ("derecho al olvido").</li>
              <li>Derecho a la Limitación: Derecho a restringir el tratamiento.</li>
              <li>Derecho de Oposición: Derecho a oponerse al tratamiento (por ejemplo, para Google Analytics).</li>
              <li>Derecho a la Portabilidad: Derecho a recibir sus datos en un formato estructurado.</li>
            </ul>
            <p className="mb-4">Por favor, contáctenos en la dirección indicada arriba para ejercer sus derechos.</p>
            
            <h4 className="text-lg font-semibold mb-2">7. Transferencia de Datos</h4>
            <p className="mb-2">Sus datos solo se transferirán si:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Es necesario para proporcionar nuestros servicios (por ejemplo, a laboratorios para prótesis dentales).</li>
              <li>Existe una obligación legal.</li>
              <li>Usted ha dado su consentimiento explícito.</li>
              <li>Google Analytics transfiere datos a servidores de Google en los EE. UU. Google cumple con el Marco de Privacidad de Datos UE-EE. UU.</li>
            </ul>
            
            <h4 className="text-lg font-semibold mb-2">8. Período de Almacenamiento</h4>
            <p className="mb-4">Almacenamos sus datos solo durante el tiempo necesario para los fines especificados o según lo requieran los períodos de retención legales. Los datos de uso (por ejemplo, Google Analytics) se eliminan después de 14 meses, a menos que se requiera un almacenamiento más prolongado.</p>
            
            <h4 className="text-lg font-semibold mb-2">9. Seguridad</h4>
            <p className="mb-4">Implementamos medidas técnicas y organizativas para proteger sus datos contra accesos no autorizados, pérdidas o usos indebidos (por ejemplo, cifrado SSL del sitio web).</p>
            
            <h4 className="text-lg font-semibold mb-2">10. Contacto</h4>
            <p className="mb-4">Para preguntas sobre protección de datos o para ejercer sus derechos, contáctenos:<br />
            Seadent Mallorca<br />
            Avenida de Jaime III, 3, 07012 Palma, Illes Balears, España<br />
            Teléfono: +34 603 31 96 48 (servicio de emergencia 24/7)<br />
            Horario: Lunes a viernes, 9:00–18:00<br />
            Correo electrónico: info@seadent.es</p>
            
            <h4 className="text-lg font-semibold mb-2">11. Cambios en esta Política de Privacidad</h4>
            <p className="mb-4">Nos reservamos el derecho de actualizar esta política de privacidad según sea necesario, por ejemplo, debido a cambios legales. La versión actual está disponible en nuestro sitio web.</p>
            <p className="mb-4">Fecha: Mayo de 2025</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrivacyPage; 